// src/components/ProtectedRoute.tsx
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import type {JSX} from "react";

type AllowedRole = 'admin' | 'super' | 'user' | 'driver';

interface ProtectedRouteProps {
    children: JSX.Element;
    allowedRoles?: AllowedRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps): JSX.Element {
    const { user, profile, loading } = useAuth()
    const location = useLocation()

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (allowedRoles?.length && !allowedRoles.includes(profile?.role as AllowedRole)) {
        return <Navigate to="/" replace />
    }

    return children
}